import { render, staticRenderFns } from "./PdfGrade.vue?vue&type=template&id=e27103e8&scoped=true&"
import script from "./PdfGrade.vue?vue&type=script&lang=ts&"
export * from "./PdfGrade.vue?vue&type=script&lang=ts&"
import style0 from "./PdfGrade.vue?vue&type=style&index=0&id=e27103e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27103e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
